import { render, staticRenderFns } from "./emailTemplates.vue?vue&type=template&id=d97caa6e&"
import script from "./emailTemplates.vue?vue&type=script&lang=js&"
export * from "./emailTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports